import { useFieldArray, useFormContext } from 'react-hook-form'

import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { Col2x, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

import { CommodityTypeItem } from './CommodityTypeItem'

export const CommodityTypes = () => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `suspiciousActivityInfo.commodityTypes`
  })

  return (
    <>
      <FormRow>
        <Col2x>
          <h5>47. Commodity type (if applicable)</h5>
        </Col2x>
      </FormRow>
      {fields.map((field, index) => (
        <CommodityTypeItem key={field.id} index={index} rowsNumber={fields.length} onDelete={remove} />
      ))}
      <FormRow>
        <IconButton face="positive" icon={IconName.ADD_GREEN} onClick={() => append({ value: '' })} />
      </FormRow>
    </>
  )
}
